export { default } from "./CouponMessage";
